package com.essntl.features.service.data.supabase.extraservice

import com.essntl.features.service.domain.model.extraservice.ExtraServiceModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun ExtraServiceModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["service_id"] = JsonPrimitive(service.id)

    requestMap["quantity"] = JsonPrimitive(quantity ?: 1)

    description?.let {
        requestMap["description"] = JsonPrimitive(it)
    }

    unitPrice?.let {
        requestMap["unit_price"] = JsonPrimitive(it)
    }

    return requestMap
}